export default function translate(key) {
  const language = window.___APP_CONFIG___.Account;
  return language || key;
}
